// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-static-save\" id=\"saveBtn\"> <i class=\"fa fa-save\"></i> <!-- ko text: _labels.SAVE --><!-- /ko --> </a>";
// Exports
export default code;